module.exports = __webpack_public_path__ + "static/media/login-video-bg.80f2eee3.mp4";